import { MutationCache, QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

export function createQueryClient() {
  const client: QueryClient = new QueryClient({
    // Qualquer alteração salva pode concluir um passo da configuração guiada: a barra do topo confere de novo.
    mutationCache: new MutationCache({ onSuccess: () => void client.invalidateQueries({ queryKey: ['setup'] }) }),
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        refetchOnWindowFocus: false,
        // Erro de regra (4xx) não melhora tentando de novo.
        retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
      },
      mutations: { retry: false },
    },
  });
  return client;
}
